export default "/icon-radio-checked.svg";